module.exports = __webpack_public_path__ + "img/perm_camera_mic.9cbc6494.svg";